module.exports = __webpack_public_path__ + "static/img/nature.39042d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nature.jpg
// module id = 27
// module chunks = 1